import { RouteComponentProps, withRouter } from 'react-router-dom';
import ToolTable from './ToolTable';

export interface Props extends RouteComponentProps {}

export default withRouter(ToolTable as any);

